import { RegrelloSpinner } from "@regrello/ui-core";
import { useEffect, useState } from "react";
import { HttpStatusCode } from "../../../../constants/HttpStatusCodes";
import { RegrelloRestApiService } from "../../../../services/RegrelloRestApiService";
import RegrelloLogo from "./regrelloLogoFull.svg?react";

export function PersonalizedLogo({ granularAccessToken }: { granularAccessToken?: string }) {
  // (zstanik): Request the workspace's personalization settings so the customized logo can be
  // rendered below.
  const [logoBase64, setLogoBase64] = useState<string | undefined>(undefined);
  const [isWorkspacePersonalizationLoading, setIsWorkspacePersonalizationLoading] = useState(true);

  useEffect(() => {
    if (granularAccessToken == null || !isWorkspacePersonalizationLoading) {
      return;
    }

    void RegrelloRestApiService.getWorkspacePersonalization(granularAccessToken).then((resp) => {
      if (resp.status === HttpStatusCode.Ok) {
        setLogoBase64(resp.json.Logo?.value ?? undefined);
      } else {
        setLogoBase64(undefined);
      }
      setIsWorkspacePersonalizationLoading(false);
    });
  }, [granularAccessToken, isWorkspacePersonalizationLoading]);

  if (isWorkspacePersonalizationLoading) {
    return <RegrelloSpinner />;
  }

  if (logoBase64 != null) {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    return <img alt="logo" className="max-w-35 max-h-10 object-contain" src={logoBase64} />;
  }

  return <RegrelloLogo height={40} width={164} />;
}
